import React, { FC } from "react";
import { UppyComponent } from "./UppyComponent";
import { UploaderLogicComponent } from "./UploaderLogicComponent";

import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import "@uppy/file-input/dist/style.css";
import "./uploader.module.scss";
import { ProjectT, VersionT } from "../../models/models";
import FineUploaderComponent from "./FineUploaderComponent";

type UploaderPropTypes = {
  versions: VersionT[];
  projectId: number;
  project: ProjectT;
  handleClose: () => void;
}

const Uploader: FC<UploaderPropTypes> = (props) => {
  const { versions, projectId, handleClose, project } = props;

  return (
    <UploaderLogicComponent>
      <FineUploaderComponent
        versions={versions}
        projectId={projectId}
        project={project}
        handleClose={handleClose}
      />
    </UploaderLogicComponent>
  );
};
export default Uploader;
